import default_messages from "./messages.json";
import * as axios from "axios";


export const getMessage = (type, key, messages) => {
    const getDefaultMessage = (type, key) => {
        if (!default_messages[type]) {
            if (!default_messages.default[navigator.language]) {
                if (!default_messages.default.default[key]) {
                    return (default_messages.default.default.nokey);
                }
                return (default_messages.default.default[key]);
            } else {
                if (!default_messages.default[navigator.language][key]) {
                    if (!default_messages.default.default[key]) {
                        return (default_messages.default.default.nokey);
                    }
                    return (default_messages.default.default[key]);
                } else {
                    return (default_messages.default.default[key]);
                }
            }
        } else {
            if (!default_messages[type][navigator.language]) {
                if (!default_messages[type].default || !default_messages[type].default[key]) {
                    if (!default_messages.default.default[key]) {
                        return (default_messages.default.default.nokey);
                    }
                    return (default_messages.default.default[key]);
                }
                return (default_messages[type].default[key]);
            } else {
                if (!default_messages[type][navigator.language][key]) {
                    if (!default_messages[type].default[key]) {
                        return (default_messages[type].default.nokey);
                    }
                    return (default_messages[type].default[key]);
                } else {
                    return (default_messages[type][navigator.language][key]);
                }
            }

        }
    }

    if (messages && messages[type] && messages[type][navigator.language] && messages[type][navigator.language][key]) {
        return (messages[type][navigator.language][key]);
    }

    if (messages && messages[type] && messages[type].default && messages[type].default[key]) {
        return (messages[type].default[key]);
    }

    return (getDefaultMessage(type, key));

}


export const loadMessages = (url, cb) => {

        axios({
            method: "get",
            url: url
        })
            .then(response => {
                    cb(null, response.data);
                }
            )
            .catch((error) => {
                cb(error, null);
            });
}

export const getDv = (rut) => {
    const chars = rut.split('');
    const suma = 11 - chars.reduceRight((acc, elem, index) => {
        return (acc + elem * (2 + (rut.length - 1 - index) % 6)) % 11;
    }, 0);
    switch (suma) {
        case 10:
            return 'K';
        case 11:
            return 0;
        default:
            return suma;
    }

};